/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetDictionaryDto } from './GetDictionaryDto';
import {
    GetDictionaryDtoFromJSON,
    GetDictionaryDtoFromJSONTyped,
    GetDictionaryDtoToJSON,
} from './GetDictionaryDto';

/**
 * 
 * @export
 * @interface GetExaminedDto
 */
export interface GetExaminedDto {
    /**
     * 
     * @type {string}
     * @memberof GetExaminedDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetExaminedDto
     */
    surname?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetExaminedDto
     */
    firstname?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetExaminedDto
     */
    pesel?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetExaminedDto
     */
    iDCardNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetExaminedDto
     */
    iDCardType?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof GetExaminedDto
     */
    dateOfBirth?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof GetExaminedDto
     */
    education?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetExaminedDto
     */
    drivingLicense?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetExaminedDto
     */
    sex?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetExaminedDto
     */
    street?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetExaminedDto
     */
    numbers?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetExaminedDto
     */
    city?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetExaminedDto
     */
    postcode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetExaminedDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetExaminedDto
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetExaminedDto
     */
    postalAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetExaminedDto
     */
    learnedProfession?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetExaminedDto
     */
    drivingLicenseIssuer?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GetExaminedDto
     */
    drivingLicenseYear?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GetExaminedDto
     */
    nationality?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetExaminedDto
     */
    nip?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetExaminedDto
     */
    invoiceName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetExaminedDto
     */
    invoiceAddress?: string | null;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetExaminedDto
     */
    country?: GetDictionaryDto | null;
    /**
     * 
     * @type {string}
     * @memberof GetExaminedDto
     */
    countryId?: string | null;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetExaminedDto
     */
    idCardTypeDict?: GetDictionaryDto | null;
    /**
     * 
     * @type {string}
     * @memberof GetExaminedDto
     */
    idCardTypeDictId?: string | null;
}

/**
 * Check if a given object implements the GetExaminedDto interface.
 */
export function instanceOfGetExaminedDto(value: object): value is GetExaminedDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function GetExaminedDtoFromJSON(json: any): GetExaminedDto {
    return GetExaminedDtoFromJSONTyped(json, false);
}

export function GetExaminedDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetExaminedDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'surname': json['surname'] == null ? undefined : json['surname'],
        'firstname': json['firstname'] == null ? undefined : json['firstname'],
        'pesel': json['pesel'] == null ? undefined : json['pesel'],
        'iDCardNumber': json['iDCardNumber'] == null ? undefined : json['iDCardNumber'],
        'iDCardType': json['iDCardType'] == null ? undefined : json['iDCardType'],
        'dateOfBirth': json['dateOfBirth'] == null ? undefined : (new Date(json['dateOfBirth'])),
        'education': json['education'] == null ? undefined : json['education'],
        'drivingLicense': json['drivingLicense'] == null ? undefined : json['drivingLicense'],
        'sex': json['sex'] == null ? undefined : json['sex'],
        'street': json['street'] == null ? undefined : json['street'],
        'numbers': json['numbers'] == null ? undefined : json['numbers'],
        'city': json['city'] == null ? undefined : json['city'],
        'postcode': json['postcode'] == null ? undefined : json['postcode'],
        'email': json['email'] == null ? undefined : json['email'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'postalAddress': json['postalAddress'] == null ? undefined : json['postalAddress'],
        'learnedProfession': json['learnedProfession'] == null ? undefined : json['learnedProfession'],
        'drivingLicenseIssuer': json['drivingLicenseIssuer'] == null ? undefined : json['drivingLicenseIssuer'],
        'drivingLicenseYear': json['drivingLicenseYear'] == null ? undefined : json['drivingLicenseYear'],
        'nationality': json['nationality'] == null ? undefined : json['nationality'],
        'nip': json['nip'] == null ? undefined : json['nip'],
        'invoiceName': json['invoiceName'] == null ? undefined : json['invoiceName'],
        'invoiceAddress': json['invoiceAddress'] == null ? undefined : json['invoiceAddress'],
        'country': json['country'] == null ? undefined : GetDictionaryDtoFromJSON(json['country']),
        'countryId': json['countryId'] == null ? undefined : json['countryId'],
        'idCardTypeDict': json['idCardTypeDict'] == null ? undefined : GetDictionaryDtoFromJSON(json['idCardTypeDict']),
        'idCardTypeDictId': json['idCardTypeDictId'] == null ? undefined : json['idCardTypeDictId'],
    };
}

export function GetExaminedDtoToJSON(value?: GetExaminedDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'surname': value['surname'],
        'firstname': value['firstname'],
        'pesel': value['pesel'],
        'iDCardNumber': value['iDCardNumber'],
        'iDCardType': value['iDCardType'],
        'dateOfBirth': value['dateOfBirth'] == null ? undefined : ((value['dateOfBirth'] as any).toISOString()),
        'education': value['education'],
        'drivingLicense': value['drivingLicense'],
        'sex': value['sex'],
        'street': value['street'],
        'numbers': value['numbers'],
        'city': value['city'],
        'postcode': value['postcode'],
        'email': value['email'],
        'phone': value['phone'],
        'postalAddress': value['postalAddress'],
        'learnedProfession': value['learnedProfession'],
        'drivingLicenseIssuer': value['drivingLicenseIssuer'],
        'drivingLicenseYear': value['drivingLicenseYear'],
        'nationality': value['nationality'],
        'nip': value['nip'],
        'invoiceName': value['invoiceName'],
        'invoiceAddress': value['invoiceAddress'],
        'country': GetDictionaryDtoToJSON(value['country']),
        'countryId': value['countryId'],
        'idCardTypeDict': GetDictionaryDtoToJSON(value['idCardTypeDict']),
        'idCardTypeDictId': value['idCardTypeDictId'],
    };
}

